import { formatCurrency } from "helpers/currency";
import CallButton from "components/CallButton";

export type FooterPlacement = "viewport" | "panel";

const PLACEMENT_CLASS: Record<FooterPlacement, string> = {
  viewport: "fixed bottom-0 left-0 right-0 z-50",
  panel: "sticky bottom-0 z-10 mt-auto",
};

/**
 * Price, view details link, and call CTA. `viewport` pins the bar to the
 * window; `panel` keeps it at the bottom of the scrolling container it is
 * rendered in, so it never covers a sidebar beside that container.
 */
export default function FixedFooterBar({
  total,
  onViewDetails,
  placement = "viewport",
}: {
  total: number;
  onViewDetails: () => void;
  placement?: FooterPlacement;
}) {
  return (
    <div className={`${PLACEMENT_CLASS[placement]} bg-ivory px-3 py-2`}>
      <div className="mx-auto flex max-w-lg items-center justify-between">
        {/* Price and View Details */}
        <div className="flex flex-col items-center">
          <p className="text-2xl font-bold text-evergreen">
            {formatCurrency(total)}
          </p>
          <button
            onClick={onViewDetails}
            className="pt-0 text-xs font-medium text-soil underline decoration-dotted underline-offset-2"
          >
            View details
          </button>
        </div>

        {/* Call CTA */}
        <CallButton variant="compact" />
      </div>
    </div>
  );
}
